import companies from "./companies.json";

const mockCompanies = (companyFilter = "") => {
    const results = {
        object: "suggestions",
        data: []
    };

    const companyFilterLowerCase = companyFilter.toLowerCase();

    if (companyFilter) {
        results.data = companies.filter((company) => {
            const companyLowerCase = company.text.toLowerCase();
            return companyLowerCase.includes(companyFilterLowerCase) ? company : null;
        });
    } else {
        results.data = companies;
    }

    return results;
};

export { mockCompanies };
